import { ThemeEvents } from '@theme/events';

class ProductGearpoints extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.resource?.price;
    if (newPrice === undefined || newPrice === parseInt(this.dataset.currentPrice, 10)) return;

    const newElement = event.detail.data.html.querySelector(
      `product-gearpoints[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    this.innerHTML = newElement.innerHTML;
    this.dataset.currentPrice = String(newPrice);
  };
}

if (!customElements.get('product-gearpoints')) {
  customElements.define('product-gearpoints', ProductGearpoints);
}
